<script>
	import GlobalInfo from '../GlobalInfo.vue';
	import { reqToken } from './NetHttp.js';
	import axios from 'axios';
	export default {
		
		getCookie(name) {
		  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		  if (match) return match[2];
		  return null;
		},
		setCookie(name, value, days = 30) {
			const expires = new Date();
			expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
			document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
		},
		/**
		 * 设置Session
		 * @param {Object} data
		 */
		setSessionStorage(str,data) {
			window.sessionStorage.setItem(str, data);
		},
		/**
		 * 获取Session
		 */
		getSessionStorage(str) {
			return window.sessionStorage.getItem(str)
		},
		/**
		 * 清理Session
		 */
		clearSessionStorage(str) {
			window.sessionStorage.removeItem(str)
		},
		/**
		 * 图片转换Base64
		 * @param {Object} img
		 * @param {Object} call
		 */
		coverImgToBase64(img, call) {
			const reader = new FileReader();
			reader.addEventListener('load', () => call(reader.result));
			reader.readAsDataURL(img);
		},
		/**
		 * 转换时间为01
		 * @param {Object} m
		 */
		coverTime(m) {
			return m < 10 ? '0' + m : m
		},
		/**
		 * 转换时间为年-月-日 时：分：秒
		 * @param {Object} seconds
		 */
		coverTimeToFormat(seconds) {
			var time = new Date(seconds);
			var y = time.getFullYear();
			var m = time.getMonth() + 1;
			var d = time.getDate();
			var h = time.getHours();
			var mm = time.getMinutes();
			var s = time.getSeconds();
			var week = {
			  0: '星期天',
			  1: '星期一',
			  2: '星期二',
			  3: '星期三',
			  4: '星期四',
			  5: '星期五',
			  6: '星期六'
			 };
			return y + '年' + this.coverTime(m) + '月' + this.coverTime(d) + "日 | "+ week[time.getDay()]+" | " + this.coverTime(h) + ':' + this.coverTime(
				mm);
		},
		/**
		 * 获取fontSize的文字大小
		 * @param {Object} num
		 */
		getFitSize(num) {
			var clientWidth = document.documentElement.scrollWidth;
			return GlobalInfo.fitData.fontSize * (clientWidth / GlobalInfo.fitData.windowSize.width) * num
		},
		/**
		 * 获取时间
		 */
		getTime() {
			return Date.parse(new Date())
		},
		/**数组转换为对象 */
		coverArrToObject(arr, key) {
			var data = {};
			if (arr) {
				arr.forEach((res) => {
					data[res[key]] = res
				})
			};
			return data
		},
		/**刷新echarts*/
		updateEcharts(e, option) {
			setTimeout(()=>{
				e.resize();
				e.setOption(option, true);
				window.addEventListener("resize", () => {
					e.resize()
				})
			},200)
		},
		/**深拷贝*/
		clone(sObj) {
			if (sObj === null || typeof sObj !== "object") {
				return sObj
			};
	
			let s = {};
			if (sObj.constructor === Array) {
				s = []
			};
	
			for (let i in sObj) {
				if (sObj.hasOwnProperty(i)) {
					s[i] = this.clone(sObj[i])
				}
			};
	
			return s
		},
		covnStr(start, str) {
			const arr = str.split("");
			const end = start + 4;
			for (let i = start; i < arr.length; i++) {
				if (i > start && i <= end) {
					arr[i] = "*"
				}
			};
			let txt = "";
			for (let i = 0; i < arr.length; i++) {
				txt += arr[i]
			};
		
			return txt
		},
		/**
		 * 获取用户信息
		 * @param {Function} callback 回调函数，参数为用户数据
		 * @param {Function} resetCallback 重置回调函数
		 */
		getUserInfo(callback, resetCallback) {
			reqToken("post", "/sso/getCurrInfo").then((res) => {
				if (res.code != 200) {
					if (resetCallback) {
						resetCallback();
					}
				} else {
					if (callback) {
						callback(res.data);
					}
				}
			})
		},
		/**
		 * 用户登录
		 * @param {String} clientLoginUrl 登录后跳转地址
		 * @param {Function} callback 成功回调
		 * @param {Function} errorCallback 错误回调
		 */
		userLogin(clientLoginUrl, callback, errorCallback) {
			const formData = new URLSearchParams();
			formData.append('clientLoginUrl', clientLoginUrl || location.href);
			
			axios.post("/sso/getSsoAuthUrl", formData).then((res) => {
				if (res.data.code != 200) {
					if (errorCallback) {
						errorCallback(res.data.msg);
					}
				} else {
					if (callback) {
						callback(res.data.data);
					}
				}
			}).catch((err) => {
				if (errorCallback) {
					errorCallback(err.message || '登录失败');
				}
			});
		},
		/**
		 * 用户登出
		 * @param {Function} callback 成功回调
		 * @param {Function} errorCallback 错误回调
		 */
		userLogout(callback, errorCallback) {
			const formData = new URLSearchParams();
			formData.append('singleDeviceIdLogout', 'true');
			
			axios.post("/sso/logout", formData).then((res) => {
				if (res.data.code != 200) {
					if (errorCallback) {
						errorCallback(res.data.msg);
					}
				} else {
					if (callback) {
						callback();
					}
				}
			}).catch((err) => {
				if (errorCallback) {
					errorCallback(err.message || '登出失败');
				}
			});
		},
		/**
		 * 清除指定的cookie
		 * @param {string} name cookie名称
		 * @param {string} path cookie路径，默认为"/"
		 * @param {string} domain cookie域名，默认为当前域名
		 */
		clearCookie(name, path = "/", domain = window.location.hostname) {
			// 清除cookie，设置过期时间为过去的时间
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=" + path;
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=" + path + ";domain=" + domain;
		},
		isLogin(callback, errorCallback) {
			axios.get("/sso/isLogin").then((res) => {
				if (res.data.code != 200) {
					if (errorCallback) {
						errorCallback(res.data.msg);
					}
				} else {
					if (callback) {
						callback(res.data.data);
					}
				}
			}).catch((err) => {
				if (errorCallback) {
					errorCallback(err.message || '访问失败');
				}
			});
		},
		/**
				 * 检查登录状态并跳转到指定URL
				 * @param {string} targetUrl 目标跳转地址
				 * @param {Function} successCallback 成功回调
				 * @param {Function} errorCallback 错误回调
				 */
				checkLoginAndJump(targetUrl, successCallback, errorCallback) {
					this.isLogin(
						(data) => {
							if (data) {
								// 已登录，直接跳转
								if (successCallback) {
									successCallback(data);
								} else {
									window.location.href=targetUrl;
								}
							} else {
								// 未登录，先登录再跳转
								this.userLogin(
									targetUrl,
									(loginData) => {
										window.location.href = loginData;
									},
									(msg) => {
										if (errorCallback) {
											errorCallback(msg);
										} else {
											this.$message.error(msg);
										}
									}
								);
							}
						},
						(msg) => {
							if (errorCallback) {
								errorCallback(msg);
							} else {
								this.$message.error(msg);
							}
						}
					);
				},
	};
</script>